module.exports = __webpack_public_path__ + "static/media/slider3.d9eef572.jpg";